













































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import ZkTable from 'vue-table-with-tree-grid'
import AbpBase from '@/lib/abpbase'
import NavSetApi from '@/api/shopMall/navSet'

@Component({
  components: {
    [ZkTable.name]: ZkTable
  }
})
export default class GoodsCategory extends AbpBase {
  columns: any[] = [
    {
      label: '分类名称',
      prop: 'name'
    },
    {
      label: '排序',
      prop: 'displayOrder'
    },
    {
      label: '操作',
      type: 'template',
      template: 'action',
      width: 270,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []

  created() {
    this.getData()
  }

  /**
   * 获取所有分类
   */
  getData() {
    NavSetApi.getAll().then(res => {
      this.tableData = this.listToTree(res.data.items)
    })
  }

  /**
   * 删除分类
   */
  deleteBrand(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    NavSetApi.deleteById(id).then(res => {
      this.getData()
    })
  }

  listToTree(list) {
    let map = {},
      node,
      roots = []
    for (let i = 0; i < list.length; i += 1) {
      map[list[i].id] = i
      list[i].children = []
    }
    for (let i = 0; i < list.length; i += 1) {
      node = list[i]
      if (node.parentId !== null) {
        if(map[node.parentId] != null) {
          list[map[node.parentId]].children.push(node)
        }
      } else {
        roots.push(node)
      }
    }
    return roots
  }

  handleBeforeChange() {
    return new Promise((resolve, reject) => {
      return reject()
    })
  }
}
